<template>
  <section
    class="component-a7efd289"
    resmed-component-name="form_50/50_icon-line_text"
    v-bind:class="{ '-options-bg-img': obj.layout['-options'] === 'image' }"
    v-bind:style="style"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row align-items-center">
          <div class="col-md-6 offset-md-0 col-xl-5 offset-xl-1 mb-5 mb-lg-0">
            <h2 class="-heading-xl">{{ obj.headline }}</h2>
            <p>{{ obj.content }}</p>
          </div>
          <div class="col-md-6 col-xl-6" style="min-height: 200px">
            <div class="pl-0 pl-lg-4">
              <form v-bind:id="`mktoForm_${form}`"></form>
              <!-- <form id="mktoForm_1899"></form> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import inview from '../../mixins/inview';
import marketo from "../../mixins/marketo-form";
import scrollTarget from "../../mixins/scroll-target";

export default {
  name: "component-a7efd289", // form_50/50_icon-line_text
  mixins: [marketo, scrollTarget],
  // mixins: [ inview, marketo ],
  props: ["obj"],
  data() {
    return {
      account: this.obj.account_prod,
      form: this.obj.id,
      style: {},
    };
  },
  mounted() {
    let hex = this.obj.layout["color-gradient"]; // either hex or gradient

    if (hex && this.obj.layout["-options"] !== "image") {
      this.style["background"] = hex;
    }

    if (
      location.hostname ===
        "falcon-sbx-1.eba-g4cd8xpy.us-west-2.elasticbeanstalk.com" ||
      location.hostname === "localhost.resmed.com"
    ) {
      this.account = this.obj.account_dev;
      this.form = this.obj.id_dev ? this.obj.id_dev : "1033"; // // fallback to prod id
    }

    this.marketo_form();
  },
  created() {
    this.munchkin();
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a7efd289 {
  background-color: $cc-resmed-bg-grey-4;

  // CMS options
  &.-options-bg-img {
    background-image: url(#{$assets}/images/join-community-bg@3x.png);
    background-size: 400px;
    background-position: left -310px;
    background-repeat: no-repeat;

    @media (min-width: 576px) {
      background-size: 390px;
      background-position: -90px -100px;
    }

    @media (min-width: 992px) {
      background-size: 410px;
      background-position: left center;
    }
  }

  padding: 5rem 0 4rem 0;
  min-height: 550px;
}

h2 {
  position: relative;
  margin-bottom: 0.75rem;

  @extend %eyebrow-left;
}

p {
  @media (min-width: 768px) {
    max-width: 280px;
  }

  @media (min-width: 992px) {
    max-width: 390px;
  }
}
</style>